
import { Navigation } from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Footer } from "@/components/Footer";
import {
  Book,
  Target,
  Settings,
  Shield,
  Coins,
  Users
} from "lucide-react";
import {SEO} from "@/components/SEO.tsx";
import React from "react";

const Whitepaper = () => {
  const sections = [
    {
      title: "Introduction",
      icon: <Book className="w-6 h-6" />,
      content: "Our innovative polling platform is designed to revolutionize the way businesses gather market insights and engage with their audience. By combining gamification elements with robust polling mechanics, we're creating an ecosystem where user participation is both rewarding and meaningful. Blankpoll has no association whatsoever with betting or any related activities.!"
    },
    {
      title: "Mission & Vision",
      icon: <Target className="w-6 h-6" />,
      content: "We strive to bridge the gap between businesses and their target audience through engaging polls and rewards. Our vision extends beyond traditional polling, as we aim to evolve into a comprehensive blockchain-based ecosystem by 2026, transforming the way users interact with market research and receive value for their participation."
    },
    {
      title: "Technology",
      icon: <Settings className="w-6 h-6" />,
      content: "Our platform currently operates on a secure, centralized infrastructure that ensures reliable and efficient poll operations. Users earn points through active participation, which can be redeemed in our benefits program. We plan to transition to a blockchain infrastructure, enabling more transparent and decentralized operations."
    },
    {
      title: "Security",
      icon: <Shield className="w-6 h-6" />,
      content: "Security is paramount in our system. We implement industry-standard encryption and multiple layers of security measures to protect user data and ensure fair participation. Our platform undergoes regular security audits and we maintain strict compliance with data protection regulations. As we transition to blockchain technology, we'll incorporate additional security features inherent to distributed ledger systems."
    },
    {
      title: "Tokenomics",
      icon: <Coins className="w-6 h-6" />,
      content: "Currently, users earn points through platform participation, which can be redeemed for partner rewards and benefits. We plan to implement a comprehensive tokenomics system where accumulated points can be converted to utility tokens. These tokens will offer enhanced functionality, including trading capabilities and expanded use cases within our ecosystem."
    },
    {
      title: "Community & Governance",
      icon: <Users className="w-6 h-6" />,
      content: "Our community is at the heart of everything we do. Users currently influence platform development through feedback and active participation. As we evolve, we'll introduce more formal governance mechanisms, culminating in a DAO structure by 2026 that will allow token holders to participate in key platform decisions and shape the future of our ecosystem."
    }
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-background">
      <SEO
          title="Whitepaper"
          description="Dive into the philosophy, technology, and economics behind our platform"
          type="website"
          name="blankpoll"
          imageUrl="/blankpoll-banner.jpg"
      />
      <Navigation />

      <div className="container mx-auto pt-24 px-4 pb-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4 dark:text-white">Whitepaper</h1>
            <p className="text-gray-600 dark:text-gray-300">
              A comprehensive overview of our innovative polling platform and future vision.
            </p>
          </div>

          <ScrollArea className="h-full">
            <div className="space-y-8">
              {sections.map((section, index) => (
                <Card key={index} className="dark:bg-gray-800/50 dark:border-gray-700">
                  <CardContent className="p-6">
                    <div className="flex items-center gap-4">
                      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary/10 dark:bg-gray-700 flex items-center justify-center dark:text-gray-300">
                        {section.icon}
                      </div>
                      <div>
                        <h2 className="text-xl font-semibold mb-2 dark:text-white">{section.title}</h2>
                        <p className="text-gray-600 leading-relaxed dark:text-gray-300">
                          {section.content}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </ScrollArea>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Whitepaper;
